import { Box, Divider, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import identityDocuments from "../../../../../../media/images/icons/identityDocuments.svg";
import ArrowDownSVG from "../../../../../../media/images/icons/arrow-down";
import DangerFill from "../../../../../../media/images/icons/danger-fill";
import DocumentCard from "./DocumentCard";
import CheckCircle from "../../../../../../media/images/icons/check-circle";
import CustomButton from "../../../../../components/CustomButton";
import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../../../../services/fetcher";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../hooks/useRedux";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../../../redux/features/snackbarSlice";
import {
  setDialogStatus,
  setDialogTitle,
  setOpenDialog,
} from "../../../../../../redux/features/dialogSlice";
import { setAttachFiles } from "../../../../../../redux/features/ownerSlice";

export default function IdentityDocuments() {
  const baseImageUrl =
    process.env.NODE_ENV === "development"
      ? "https://testapibazargah.bita24.com/File?name="
      : "https://api.karentarabarnet.com/File?name=";
  const [isOpen, setIsOpen] = useState(false);

  const theme = useTheme();

  const dispatch = useAppDispatch();

  const { ownerAttachs } = useAppSelector((state) => state.owner);

  const toggleBox = () => {
    setIsOpen(!isOpen);
  };

  const { trigger: getOwnerInfo, isMutating: isgetOwnerInfoMutating } =
    useSWRMutation(
      [`/Driver/GetOwnerUserInfo`, localStorage.getItem("access_token")],
      fetcherPost,
      {
        onSuccess: async (data) => {
          const { ownerAttach2, ownerAttach1, ownerAttach3, ownerAttach4 } =
            data;
          dispatch(
            setAttachFiles({
              ownerAttach1: ownerAttach1,
              ownerAttach2: ownerAttach2,
              ownerAttach3: ownerAttach3,
              ownerAttach4: ownerAttach4,
            })
          );
        },
      }
    );

  const newFormData = new FormData();

  const handleUploadFile = (file: File, title: string) => {
    if (newFormData.has(title)) {
      newFormData.delete(title);
    }
    newFormData.append(title, file);
  };

  const { trigger: postAttachFiles, isMutating: isPostAttachFilesMutating } =
    useSWRMutation(
      [`/Account/OwnerLgSetAttInfo`, localStorage.getItem("access_token")],
      fetcherPost,
      {
        onSuccess: async () => {
          dispatch(setOpenDialog(true));
          dispatch(setDialogStatus("success"));
          dispatch(setDialogTitle("ثبت اطلاعات با موفقیت انجام شد!"));
          getOwnerInfo({});
        },
        onError: (e) => {
          const { data } = e.response;
          dispatch(setOpenSnackbar(true));
          dispatch(setSnackbarErrorStatus(data.errorCode));
          dispatch(setSnackbarDescription(data.error));
        },
      }
    );

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.bgColor.white,
        display: "flex",
        flexDirection: "column",
        border: "1px solid",
        borderColor: theme.palette.bgColor.blueGrey100,
        borderRadius: "10px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "start",
          padding: "8px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "start",

            gap: "4px",
          }}
        >
          <img width={32} src={identityDocuments} alt="" />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "700",
                fontSize: "16px",
              }}
            >
              تصاویر مدارک
            </Typography>
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: "700",
              }}
            >
              کارت ملی
            </Typography>
          </Box>
        </Box>
        <CustomButton
          justifyContent="space-between"
          onClick={() => toggleBox()}
          bgColor={isOpen ? "error.light" : theme.palette.secondary[50]}
          title={isOpen ? "بستن جزئیات" : "  مشاهده/ویرایش"}
          fSize="12px"
          fWeight="600"
          rippleColor={
            isOpen ? theme.palette.error.main : theme.palette.secondary.main
          }
          borderColor={isOpen ? "error.main" : "secondary.main"}
          py="10px"
          px="6px"
          gap="4px"
          borderRadius="8px"
          textColor={isOpen ? "error.main" : "secondary.main"}
          icon2={
            <Box
              sx={{
                transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.3s",
              }}
            >
              <ArrowDownSVG
                size={14}
                color={
                  isOpen
                    ? theme.palette.error.main
                    : theme.palette.secondary.main
                }
              />
            </Box>
          }
        />
      </Box>
      <Box
        sx={{
          overflow: "hidden",
          maxHeight: isOpen ? "1500px" : 0,
          transition: isOpen ? "max-height 0.5s ease" : "max-height 0.2s ease",
          paddingX: "10px",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        <Divider variant="fullWidth" />
        <Box
          sx={{
            backgroundColor: theme.palette.primary[50],
            display: "flex",
            flexDirection: "column",
            borderRadius: "8px",
            padding: "10px",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <DangerFill color={theme.palette.primary.main} />
            <Typography
              sx={{
                color: "primary.main",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              توجه:
            </Typography>
          </Box>
          <Typography
            sx={{
              color: "primary.main",
              fontSize: "12px",
              textAlign: "justify",
            }}
          >
            در صورت ارسال عکس جدید از مدارک، حساب شما به حالت احرازنشده تبدیل
            می‌شود تا اپراتور بازارگاه مدارک را تایید کند.
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            paddingY: "16px",
            // border: "1px solid gray",
          }}
        >
          <DocumentCard
            title="OwnerAttach1"
            handleUploadFile={handleUploadFile}
            name="کارت ملی(صفحه رو)"
            urlAttach={
              ownerAttachs?.ownerAttach1
                ? `${baseImageUrl}${ownerAttachs?.ownerAttach1}`
                : undefined
            }
          />
          <DocumentCard
            title="OwnerAttach2"
            handleUploadFile={handleUploadFile}
            name="کارت ملی(صفحه پشت)"
            urlAttach={
              ownerAttachs?.ownerAttach2
                ? `${baseImageUrl}${ownerAttachs?.ownerAttach2}`
                : undefined
            }
          />
          <DocumentCard
            title="OwnerAttach3"
            handleUploadFile={handleUploadFile}
            name="تصویر روزنامه رسمی"
            urlAttach={
              ownerAttachs?.ownerAttach3
                ? `${baseImageUrl}${ownerAttachs?.ownerAttach3}`
                : undefined
            }
          />
          <DocumentCard
            title="OwnerAttach4"
            handleUploadFile={handleUploadFile}
            name="تصویر آگهی تاسیس"
            urlAttach={
              ownerAttachs?.ownerAttach4
                ? `${baseImageUrl}${ownerAttachs?.ownerAttach4}`
                : undefined
            }
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <CheckCircle size={24} color={theme.palette.success.main} />
          <Typography
            sx={{
              color: "success.main",
            }}
          >
            برای اعمال شدن تغییرات حتما ذخیره اطلاعات را بزنید
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            mb: 2,
          }}
        >
          <CustomButton
            flex={1}
            justifyContent="center"
            onClick={() => toggleBox()}
            bgColor={theme.palette.primary[50]}
            title={"انصراف"}
            fSize="16px"
            fWeight="700"
            borderColor={theme.palette.primary.main}
            py="10px"
            px="6px"
            gap="4px"
            borderRadius="6px"
            textColor={theme.palette.primary.main}
          />
          <CustomButton
            loading={isPostAttachFilesMutating || isgetOwnerInfoMutating}
            flex={1}
            justifyContent="center"
            onClick={() => {
              postAttachFiles(newFormData);
            }}
            bgColor={"primary.main"}
            title={"ذخیره اطلاعات"}
            fSize="16px"
            fWeight="700"
            py="10px"
            px="6px"
            gap="4px"
            borderRadius="6px"
            textColor={"#fff"}
          />
        </Box>
      </Box>
    </Box>
  );
}
